// extracted by mini-css-extract-plugin
export default {"root":"ViewFadeIn_root__nsipj","viewFadeIn":"ViewFadeIn_viewFadeIn__cAQuZ","lift":"ViewFadeIn_lift__2LjeX","viewFadeInLift":"ViewFadeIn_viewFadeInLift__Dmwqs"};